<script lang="ts" setup>
import BannerPicture from '~/components/banner/BannerPicture.vue'
import type { BannerData } from '~/types/banners'

defineProps<{
  bannerData: BannerData
}>()
</script>

<template>
  <div
    class="
      relative w-full overflow-hidden rounded-2xl bg-[#e7e7e7] pb-[56.25%]
      md:h-[364px] md:rounded-3xl md:pb-0
    "
  >
    <BannerPicture
      :banner-name="bannerData.attributes.name"
      class="absolute hidden size-full md:inline-block"
      :image-sources="bannerData.meta.images.desktop.sources"
      :main-image="bannerData.meta.images.desktop.main"
    />
    <BannerPicture
      :banner-name="bannerData.attributes.name"
      class="absolute inline-block size-full md:hidden"
      :image-sources="bannerData.meta.images.mobile.sources"
      :main-image="bannerData.meta.images.mobile.main"
    />
  </div>
</template>
